import { useEffect, useCallback, startTransition, useRef, useState, memo, Fragment } from 'react';
import { m, LazyMotion, AnimatePresence } from 'framer-motion';
const loadFeatures = () => import('~/utils/framerFeatures').then((res) => res.domAnimation);
// const loadFeatures = () => import('~/utils/framerFeatures').then((res) => res.domMax);
// import { motion, useInView } from 'framer-motion';
// import { useHydrated } from 'remix-utils/use-hydrated';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

// import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
// import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
// import ZoomInMap from '@mui/icons-material';
import { ZoomInMap, ZoomOutMap } from '@mui/icons-material';

const ImgEnlarger = ({
	isEnlarged,
	enlargeOnClick,
	handleShrink,
	imageCoppyRef,
}: {
	isEnlarged: boolean;
	enlargeOnClick: boolean;
	handleShrink: () => void;
	imageCoppyRef: any;
}) => {
	const theme = useTheme();
	const [iconVisible, setIconVisible] = useState<null | boolean>(null);
	const handleClickOutside = (event: MouseEvent) => {
		if (imageCoppyRef.current !== null) {
			if (imageCoppyRef.current.contains(event.target)) {
				// inside click
				return;
			}
			// outside click
			handleShrink();
		}
	};

	//* click outisde to shrink
	useEffect(() => {
		if (isEnlarged) {
			document.addEventListener('mousedown', handleClickOutside);
		}
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			// setIconVisible(null);
		};
	}, [isEnlarged]);
	return (
		<m.div
			initial={false}
			animate={{
				// width: isEnlarged ? '58.8vw' : '100%',
				width: isEnlarged ? 'clamp(700px, 55vw, 1100px)' : '100%',
				// maxWidth: isEnlarged ? '1300px' : '100%',
				x: isEnlarged ? '-51.3%' : '0%',
				y: isEnlarged ? '-25%' : '0%',
				transition: {
					duration: 0.25,
					ease: 'linear',
				},
			}}
			onAnimationComplete={(e: any) => {
				// console.log(e);
				if (e.width === '100%') {
					// console.log('onAnimationComplete');
					// kill the imageCoppyRef
					imageCoppyRef.current.src = '';
					imageCoppyRef.current.style.pointerEvents = 'none';
					setIconVisible(false);
				} else {
					setIconVisible(true);
				}
			}}
			onClick={handleShrink}
			style={{
				width: '100%',
				// maxWidth: 'clamp(8.8vw, 8.8vw, 300px)',
				objectFit: 'contain',
				position: 'absolute',
				zIndex: 100,
				// zIndex: isEnlarged ? 100 : 0,
				pointerEvents: 'none',
			}}
		>
			<m.img
				ref={imageCoppyRef}
				initial={false}
				animate={{
					border: isEnlarged ? `8px solid ${theme.palette.primary.light}` : 'none',
					transition: {
						duration: 0.25,
						ease: 'linear',
					},
				}}
				style={{
					width: '100%',
					// maxWidth: '1300px',
					objectFit: 'contain',
				}}
			/>

			<AnimatePresence>
				{(isEnlarged || iconVisible) && (
					<m.div
						initial={{
							width: 25,
							height: 25,
							top: '8px',
							right: '8px',
						}}
						animate={{
							width: isEnlarged ? 32 : 25,
							height: isEnlarged ? 32 : 25,
							top: isEnlarged ? '18px' : '8px',
							right: isEnlarged ? '18px' : '8px',

							// width: 30,
							// height: 30,
							transition: {
								duration: 0.25,
								ease: 'linear',
							},
						}}
						// exit={{
						// 	width: 30,
						// 	height: 30,
						// 	transition: {
						// 		duration: 0.05,
						// 		ease: 'linear',
						// 	},
						// }}
						style={{
							position: 'absolute',
							zIndex: 150,
							// background: 'transparent',
							// mixBlendMode: 'difference',
							// color: 'white',
						}}
					>
						<ZoomInMap
							sx={{
								fill: theme.palette.secondary.main,
								width: '100%',
								height: '100%',
								backgroundColor: theme.palette.primary.light,
								padding: 0.25,
							}}
						/>
					</m.div>
				)}
			</AnimatePresence>
		</m.div>
	);
};
// const ImageLoader = ({ children, delay, intersectViewportCheck, childRef, style }: any) => {
const ImageLoader = memo(
	({ children, intersectViewportCheck, childRef, style, enlargeOnClick = false }: any) => {
		const ref = useRef(null);
		const imageCoppyRef = useRef(null);
		// const isHydrated = useHydrated();

		// const isInView = useInView(ref);
		// console.log({ isInView });
		// const ImageLoader = ({ children, src, alt, delay, intersectViewportCheck, ...props }: any) => {
		const [loaded, setLoaded] = useState(false);
		const [isLoaded, setIsLoaded] = useState(false);
		const [isInView, setIsInView] = useState(false);
		const [isInViewOnPageLoad, setIsInViewOnPageLoad] = useState(false);
		const [isEnlarged, setIsEnlarged] = useState(false);
		// const [originalWidthAndHeight, setOriginalWidthAndHeight] = useState({ width: 0, height: 0 });
		const theme = useTheme();
		const isMd = useMediaQuery(theme.breakpoints.up('md'), {
			defaultMatches: true,
		});
		useEffect(() => {
			if (!loaded) setLoaded(true);
			return () => {
				setLoaded(false);
			};
		}, []);
		//* create intersection observer, check if in viewport
		useEffect(() => {
			// console.log('observer');
			let observer = null;
			if (loaded) {
				observer = new IntersectionObserver(
					(entries) => {
						if (entries[0].isIntersecting) {
							startTransition(() => {
								setIsInView(true);
							});
						}
					},
					// { threshold: 0.5, rootMargin: '0px', root: null },
				);
				if (ref.current) {
					observer.observe(ref.current);
				}

				if (isInView && isLoaded) {
					// console.log('isInView && isLoaded');
					startTransition(() => {
						setIsInViewOnPageLoad(true);
					});
					//* kill observer
					observer.disconnect();
				} else if (isLoaded) {
					//* kill observer
					observer.disconnect();
				}
			}
			return () => {
				observer?.disconnect();
			};
		}, []);

		// useEffect(() => {
		// 	console.log({ originalWidthAndHeight });
		// 	// if(isLoaded)
		// }, [originalWidthAndHeight]);

		useEffect(() => {
			if (loaded) {
				try {
					if (ref.current === null) throw new Error('ref.current is null');
					if (children?.props.src === undefined) throw new Error('No src provided');

					// const img = new Image();
					// //   img.src = src;
					// img.onload = () => {
					//   setIsLoaded(true);
					// };
					// img.src = children.props.src;
					//--------------------------------------------------
					let imgRef = childRef.current;
					// if imgRef is not img -> query img
					if (imgRef.tagName !== 'IMG') {
						imgRef = imgRef.querySelector('img');
					}
					if (imgRef.complete) {
						// console.log('Image is already loaded');
						// setIsLoaded(true);
						startTransition(() => {
							setIsLoaded(true);
						});
					} else {
						imgRef.onload = () => {
							// console.log('Image is loaded');
							// setIsLoaded(true);
							startTransition(() => {
								setIsLoaded(true);
							});
						};

						imgRef.onerror = () => {
							console.error('Image failed to load');
						};
					}
				} catch (error) {
					console.error(error);
				}
			}
		}, [loaded]);

		const hidden = {
			opacity: 0,
		};
		// const visible = {
		// 	opacity: isEnlarged && enlargeOnClick ? 0 : 1,
		// 	cursor: isEnlarged && enlargeOnClick ? 'default' : 'zoom-in',
		// 	transition: {
		// 		duration: isEnlarged && enlargeOnClick ? 0.1 : 0.3,
		// 		ease: 'linear',
		// 		//   delay: delay ? 0.3 : 0.0,
		// 	},
		// };
		// const visible = {
		// 	opacity: 1,
		// 	cursor: 'default',
		// 	transition: {
		// 		duration: 0.3,
		// 		ease: 'linear',
		// 		//   delay: delay ? 0.3 : 0.0,
		// 	},
		// };
		// const visibleWithEnlargeHandling = {
		// 	opacity: isEnlarged ? 0 : 1,
		// 	cursor: isEnlarged ? 'default' : 'zoom-in',
		// 	transition: {
		// 		duration: isEnlarged ? 0.1 : 0.3,
		// 		ease: 'linear',
		// 		//   delay: delay ? 0.3 : 0.0,
		// 	},
		// };
		// const notEntlargedAndAllowedTo = enlargeOnClick && !isEnlarged;
		const visible = {
			// opacity: enlargeOnClick && !isEnlarged ? 1 : 0,
			opacity: enlargeOnClick && !isEnlarged ? 1 : !enlargeOnClick ? 1 : 0,
			// cursor: enlargeOnClick && !isEnlarged ? 'zoom-in' : 'default',
			// cursor: enlargeOnClick && !isEnlarged ? 'zoom-in' : !enlargeOnClick ? 'default' : 'default',
			cursor: enlargeOnClick && !isEnlarged ? 'pointer' : !enlargeOnClick ? 'default' : 'default',
			transition: {
				// duration: enlargeOnClick && !isEnlarged ? 0.3 : 0.1,
				duration: enlargeOnClick && !isEnlarged ? 0.25 : !enlargeOnClick ? 0.25 : 0.1,
				ease: 'linear',
				//   delay: delay ? 0.3 : 0.0,
			},
		};
		// const visible = {
		// 	opacity: notEntlargedAndAllowedTo ? 1 : 0,
		// 	cursor: notEntlargedAndAllowedTo ? 'zoom-in' : 'default',
		// 	transition: {
		// 		duration: notEntlargedAndAllowedTo ? 0.3 : 0.1,
		// 		ease: 'linear',
		// 		//   delay: delay ? 0.3 : 0.0,
		// 	},
		// };

		const newStyle = style !== undefined ? style : { height: '100%', width: '100%' };

		const handleEnlarge = () => {
			if (enlargeOnClick && !isEnlarged && isMd) {
				// setIsEnlarged(!isEnlarged);
				let imgRef = childRef.current;
				if (imgRef.tagName !== 'IMG') {
					imgRef = imgRef.querySelector('img');
				}

				//* set img in imageCoppyRef
				if (imageCoppyRef.current !== null) {
					//@ts-expect-error
					imageCoppyRef.current.src = imgRef.src;
					//@ts-expect-error
					imageCoppyRef.current.style.pointerEvents = 'auto';
					// imageCoppyRef.current.style.cursor = 'zoom-out';
					//@ts-expect-error
					imageCoppyRef.current.style.cursor = 'pointer';
					setIsEnlarged(true);
				}
			}
		};
		const handleShrink = () => {
			if (enlargeOnClick && isEnlarged) {
				setIsEnlarged(false);
			}
		};

		// const animate = useCallback(() => {
		// 	if ((isLoaded && !intersectViewportCheck) || isInViewOnPageLoad) {
		// 		if (enlargeOnClick) {
		// 			console.log('visibleWithEnlargeHandling');
		// 			return visibleWithEnlargeHandling;
		// 		} else {
		// 			console.log('visible');
		// 			return visible;
		// 		}
		// 	} else {
		// 		console.log('hidden');
		// 		return hidden;
		// 	}
		// }, [enlargeOnClick, isEnlarged]);

		return (
			<LazyMotion strict features={loadFeatures}>
				<div style={{ position: 'relative', width: '100%', height: '100%' }}>
					{enlargeOnClick && isMd && (
						<ImgEnlarger
							isEnlarged={isEnlarged}
							enlargeOnClick={enlargeOnClick}
							handleShrink={handleShrink}
							imageCoppyRef={imageCoppyRef}
						/>
					)}
					<m.div
						// id={(children?.props.src).toString()} //! is this safe?
						onClick={handleEnlarge}
						ref={ref}
						// style={{ ...props.style, opacity: isLoaded ? 1 : 0, transition: 'opacity 1.1s ease-in-out' }}
						//   style={{ ...props.style, opacity: isLoaded && isInView ? 1 : 0, transition: 'opacity .3s ease-in-out' }}
						// initial={visible}
						initial={hidden}
						animate={(isLoaded && !intersectViewportCheck) || isInViewOnPageLoad ? visible : hidden}
						// animate={animate()}
						// animate={
						// 	(isLoaded && !intersectViewportCheck) || isInViewOnPageLoad
						// 		? enlargeOnClick
						// 			? visibleWithEnlargeHandling
						// 			: visible
						// 		: hidden
						// }
						whileInView={isLoaded && intersectViewportCheck ? visible : ''}
						viewport={{
							once: true,
							amount: 0.6,
							// margin: '200px',
						}}
						// whileInView={visible}
						// onPointerDown={() => {
						style={{
							...newStyle,
						}}
					>
						{/* <ZoomInMap /> */}
						{enlargeOnClick && isMd && (
							<ZoomOutMap
								sx={{
									fill: theme.palette.secondary.main,
									// mixBlendMode: 'difference',
									// color: 'white',
									width: 25,
									height: 25,
									position: 'absolute',
									top: '8px',
									right: '8px',
									zIndex: 150,
									backgroundColor: theme.palette.primary.light,
									padding: 0.25,
								}}
							/>
						)}
						{/* <Box component='img' src={src} alt={alt} style={{ ...props.style }} /> */}
						{children}
					</m.div>
				</div>
			</LazyMotion>
		);
	},
);

export { ImageLoader };
